const groupMembershipConfig = {
  name: 'Group Membership',
  endpoint: '/internal_admin/admin_kit/group_memberships',
  modelKey: 'rbac_group_membership',

  columns: [
    { name: 'group_name', title: 'Group', type: 'link' },
    { name: 'user_email', title: 'User' },
    { name: 'discarded_at', title: 'Discarded' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[group_name_cont]', label: 'Group' },
    { name: 'q[user_email_cont]', label: 'User Email' },
    {
      name: 'q[discarded]',
      label: 'Status',
      allLabel: 'Active only',
      options: () => [{ id: 'only', label: 'Discarded only', value: 'only' }],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'group_name', label: 'Group' },
    { name: 'user_email', label: 'User' },
    { name: 'discarded_at', label: 'Discarded At' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'group_id',
        label: 'Group',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/group_memberships/group_search',
        displayField: 'group_name',
        required: true,
      },
      {
        name: 'user_id',
        label: 'User',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/group_memberships/user_search',
        displayField: 'user_email',
        required: true,
      },
    ],
  },
};

export default groupMembershipConfig;
